export const SET_USERS = 'SET_USERS';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const SET_USER = 'SET_USER';
export const SET_USER_ROLE = 'SET_USER_ROLE';
export const SET_USER_ID = 'SET_USER_ID';

export const setUsers = (users) => ({
  type: SET_USERS,
  payload: users
});

export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  payload: isLoading
});

export const setError = (error) => ({
  type: SET_ERROR,
  payload: error
});

export const setUserName = (userName) => ({
  type: SET_USER,
  payload: userName
});

export const setUserRole = (role) => ({
  type: SET_USER_ROLE,
  payload: role
});

export const setUserId = (id) => ({
  type: SET_USER_ID,
  payload: id
});
